import { t } from "@repo/translation";
import { hasItems, isDefined, searchWithNormalizedInclude } from "@repo/utils";
import isEmpty from "lodash/isEmpty";
import { useEffect, useState } from "react";

import { DebouncedSearchField } from "./DebouncedSearchField";
import { SectionContainer } from "./SectionContainer";
import {
  type SelectListItem,
  SelectListView,
  type SelectListViewProps,
} from "./SelectListView";

interface SearchSelectProps extends Pick<
  SelectListViewProps,
  "onChange" | "selectAll" | "selectionMode"
> {
  localState?: string[];
  values?: [string, string][];
  showSearch?: boolean;
}

export const SearchSelect = ({
  onChange,
  localState,
  selectionMode,
  values,
  selectAll,
  showSearch = true,
}: SearchSelectProps) => {
  const [searchValue, setSearchValue] = useState<string>("");
  const [searchResult, setSearchResult] = useState<SelectListItem[]>();

  const mappedValueList =
    values?.map((el) => ({
      value: el[0],
      name: el[0],
      description: el[1],
    })) ?? [];

  const handleChange = (term: string) => {
    setSearchValue(term);
  };

  const handleSearch = () => {
    const filteredList = mappedValueList?.filter(
      (value) =>
        searchWithNormalizedInclude(searchValue, value.name) ||
        searchWithNormalizedInclude(searchValue, value.description)
    );

    setSearchResult(filteredList);
  };

  useEffect(() => {
    if (isEmpty(searchValue)) {
      setSearchResult(mappedValueList);
    } else {
      handleSearch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValue]);

  return (
    <SectionContainer>
      {showSearch && (
        <DebouncedSearchField
          id="searh-selected-items"
          dataTestId="search-select-modal"
          placeholder={t("action.placeholder_search")}
          value={searchValue}
          onChange={(term) => handleChange(term)}
        />
      )}

      {hasItems(searchResult) && (
        <SelectListView
          id="search-select-list"
          list={searchResult}
          selectedKeys={localState?.filter(isDefined) ?? []}
          onChange={onChange}
          selectionMode={selectionMode}
          selectAll={selectAll}
        />
      )}
    </SectionContainer>
  );
};
